import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { every, isNumber } from "lodash";
import { sntTranslate } from "src/app/support/translate";
import DevExpress from "devextreme";

export type ValidationRules = Array<
  | DevExpress.ui.RequiredRule
  | DevExpress.ui.NumericRule
  | DevExpress.ui.RangeRule
  | DevExpress.ui.StringLengthRule
  | DevExpress.ui.CustomRule
  | DevExpress.ui.CompareRule
  | DevExpress.ui.PatternRule
  | DevExpress.ui.EmailRule
  | DevExpress.ui.AsyncRule
>;

export interface ValidationItem {
  validate(): boolean;
}

@Injectable()
export class ValidationService {
  private groups: Map<string, Array<ValidationItem>> = new Map();

  addToGroup(name: string, item: ValidationItem): void {
    if (!this.groups.has(name)) {
      this.groups.set(name, []);
    }

    this.groups.get(name)?.push(item);
  }

  removeGroup(name: string): void {
    this.groups.delete(name);
  }

  validateGroup(groupName: string): boolean {
    const ret =
      this.groups.get(groupName)?.map((item) => item.validate()) || [];

    return every(ret, (x) => !!x);
  }

  validateRules(value: any, rules: ValidationRules): string[] {
    let errors: string[] = [];

    for (const rule of rules) {
      switch (rule.type) {
        case "required": {
          if (!value && !isNumber(value)) {
            errors.push(
              rule.message || sntTranslate(marker("Campo richiesto"))
            );
          }
          break;
        }
        case "custom": {
          if (!rule.validationCallback!(<any>{ value: value })) {
            errors.push(
              rule.message || sntTranslate(marker("Campo richiesto"))
            );
          }
          break;
        }
      }
    }

    return errors;
  }
}
